 const INITIAL_STATE = {}
 const errorReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  const matches = /(.*)_(REQUEST|FAILURE|CLEAR)/.exec(type);

  // not a *_REQUEST / *_FAILURE actions, so we ignore them
  if (!matches) return state;

  const [, requestName, requestState] = matches;

  //
  if(requestState === 'CLEAR') {
    return INITIAL_STATE
  }
  return {
    ...state,
    // Store errorMessage
    [requestName]: requestState === 'FAILURE' ? { message: payload.message, data: payload.data } : '',
  };
};

export default errorReducer